export default __webpack_public_path__ + "static/suportero-46266d8f527c3077d9c8caf43ee4e9dc.jpg";